var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-template"},[_c('div',{staticClass:"register-wrapper"},[_c('nuxt')],1),_vm._v(" "),_c('LoaderComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }